<template>
  <div ref="strip" class="s-booking-fleet">
    <Loader v-if="isLoading" display="absolute"></Loader>
    <Alert v-if="errorMsgs.length" type="danger" :messages="errorMsgs"></Alert>

    <div class="s-booking-fleet__found mb-40">
      <div class="semibold">
        <span v-if="recordsCountFiltered === 1">
          {{ dictionary.resultsFoundPrefixSingle }}&nbsp;
        </span>
        <span v-else>{{ dictionary.resultsFoundPrefix }}&nbsp;</span>

        <span class="extrabold">
          {{ recordsCountFiltered }}

          <span v-if="recordsCountFiltered === 1">
            {{ dictionary.resultsFoundSuffixSingle }}
          </span>
          <span v-else>{{ dictionary.resultsFoundSuffix }}</span>
        </span>
        <br />
        {{ dictionary.resultsFoundInstructions }}
      </div>

      <template v-if="couponCodeApplied.exists">
        <div
          v-if="couponCodeApplied.valid"
          class="s-booking-fleet__discount extrabold">
          <CheckLottie />
          <span>
            {{ dictionary.offerCodeActivatedText }}
          </span>
        </div>
        <div v-else>
          <Alert type="danger" :messages="[dictionary.offerCodeInvalidText]" />
        </div>
      </template>

      <!-- Miles N Bonus -->
      <div
        v-if="
          milesNBonusLoggedIn &&
          showMilesNBonus &&
          mbDictionary.milesNBonusDiscountMessage
        "
        class="s-booking-fleet__discount s-booking-fleet__discount--milesNBonus extrabold">
        <CheckLottie />
        <span>
          {{ mbDictionary.milesNBonusDiscountMessage }}
        </span>
      </div>
    </div>

    <div ref="stickyElement" class="s-booking-fleet__tools mb-40">
      <div class="s-booking-fleet__tools__group">
        <div v-if="types.length" class="s-booking-fleet__my-filters">
          <label class="form-label">{{ dictionary.filtersLabel }}</label>
          <FleetFilters
            :types="types"
            :vehicles-types="vehiclesTypes"
            id-prefix="checkbox-lg"
            :show-guaranteed="showGuaranteed"
            @submit-filters="onSubmitFilters" />
        </div>

        <div class="s-booking-fleet__sort-by">
          <label for="selectSortBy" class="form-label">
            {{ dictionary.sortLabel }}
          </label>
          <select
            id="selectSortBy"
            v-model="sortBy"
            class="form-select form-select-short"
            @change="onChangeSortBy">
            <option
              v-for="(item, index) in sortByOptions"
              :key="index"
              :value="item.value">
              {{ item.text }}
            </option>
          </select>
        </div>
      </div>
      <div class="s-booking-fleet__tools__group">
        <div v-if="showMilesToggle" class="miles-n-bonus-switch">
          <div class="miles-n-bonus-switch__header">
            <div class="new">{{ mbDictionary.milesNBonusTagLabel }}</div>
            <span>{{ mbDictionary.milesNBonusToggleTitle }}</span>
          </div>
          <div class="form-check form-switch">
            <label class="form-check-label" for="toggleMiles">
              <span v-if="toggleMiles" class="is-active">
                {{ mbDictionary.milesNBonusToggleMilesLabel }}
              </span>
              <span v-else>
                {{ mbDictionary.milesNBonusToggleEuroLabel }}
              </span>
            </label>
            <input
              id="toggleMiles"
              v-model="toggleMiles"
              class="form-check-input"
              type="checkbox"
              role="switch"
              autocomplete="off"
              @change="onToggleMiles" />
          </div>
        </div>

        <div class="s-booking-fleet__view-as d-none d-lg-flex">
          <label class="form-label">{{ dictionary.viewAsLabel }}</label>
          <ul>
            <li>
              <button type="button" class="btn-clear" @click="onClickGridView">
                <div class="e-view-grid" :class="{ 'is-active': isViewGrid }">
                  <i></i>
                </div>
              </button>
            </li>
            <li>
              <button type="button" class="btn-clear" @click="onClickListView">
                <div class="e-view-list" :class="{ 'is-active': isViewList }">
                  <i></i>
                </div>
              </button>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <div
      v-if="recordsCountFiltered"
      ref="grid"
      v-auto-animate
      class="s-booking-fleet__grid mb-60"
      :class="{ 'view-list': isViewList }">
      <div
        v-for="item in recordsFilteredPaged"
        :key="item.Id"
        class="s-booking-fleet__item">
        <BookingVehicle
          :item="item"
          :is-view-grid="isViewGrid"
          :is-view-list="isViewList"
          :toggle-miles="toggleMiles" />
      </div>
    </div>

    <div v-if="!recordsCountFiltered">
      <NoResults></NoResults>
    </div>

    <div v-if="recordsCountFiltered" class="d-flex justify-content-center">
      <Pagination
        class="mb-40"
        :total-records="recordsCountFiltered"
        :per-page="itemsPerPage"
        :current-page="page"
        @pagechanged="pageChanged" />
    </div>

    <div v-if="showButtonViewAll" class="d-flex justify-content-center">
      <button
        type="button"
        class="btn btn-outline-primary"
        @click="onClickViewAll">
        {{ dictionary.buttonViewAllText }}
      </button>
    </div>
  </div>
</template>

<script>
import jQuery from 'jquery'
import * as lib from '../../lib/lib'
import BookingVehicle from './BookingVehicle.vue'
import Loader from './common/Loader.vue'
import Alert from './common/Alert.vue'
import NoResults from './common/NoResults.vue'
import FleetFilters from './FleetFilters.vue'
import constants from '../../lib/constants'
import Pagination from './../components/common/Pagination.vue'
import CheckLottie from './../components/lotties/Check.vue'
/* eslint-disable no-unused-vars */
import { orderBy } from 'lodash'
import StickyOnScroll from '../../modules/StickyOnScroll'

export default {
  components: {
    FleetFilters,
    Pagination,
    Alert,
    Loader,
    NoResults,
    BookingVehicle,
    CheckLottie,
  },

  data() {
    return {
      view: null,
      percentage: 0,
      isLoading: false,
      errorMsgs: [],
      records: [],
      recordsCount: null,
      recordsFiltered: [],
      page: 1,
      viewMoreLink: null,
      types: [],
      breakpoint: null,
      sortByOptions: [],
      itemsPerPage: 0,
      couponCodeApplied: false,
      guaranteed: false,
      sortBy: 'OrderingInitial',
      transmissions: [],
      specialCategories: [],
      vehiclesTypes: [],

      mbDictionary: {},
      milesNBonusLoggedIn: false,
      showMilesNBonus: lib.getData('milesNBonusData'),
      redeemAllowed: false,
      toggleMiles: false,
    }
  },
  computed: {
    showMilesToggle() {
      return (
        this.milesNBonusLoggedIn && this.showMilesNBonus && this.redeemAllowed
      )
    },
    showButtonViewAll() {
      return this.recordsCountFiltered > this.itemsPerPage
    },

    recordsFilteredPaged() {
      const start = (this.page - 1) * this.itemsPerPage
      const end = this.page * this.itemsPerPage
      return this.recordsFiltered.slice(start, end)
    },

    recordsCountFiltered() {
      return this.recordsFiltered.length
    },

    isViewGrid() {
      return (
        this.view === constants.view.grid &&
        this.breakpoint === constants.breakpoints.desktops
      )
    },

    isViewList() {
      return (
        this.breakpoint === constants.breakpoints.devices ||
        this.view === constants.view.list
      )
    },

    showGuaranteed() {
      return !!this.recordsFiltered.filter((i) => i.Guaranteed).length
    },
  },
  mounted() {
    // prettier-ignore
    const { records, recordsCount, types, sortByOptions, couponCodeApplied } = lib.getData('bookingData')
    this.records = this.recordsFiltered = records
    this.recordsCount = recordsCount
    this.types = types
    this.sortByOptions = sortByOptions
    this.couponCodeApplied = couponCodeApplied
    this.itemsPerPage = this.configuration.itemsPerPage

    if (lib.getData('milesNBonusData')) {
      const { dictionary, configuration } = lib.getData('milesNBonusData')
      this.milesNBonusLoggedIn = configuration.milesNBonusLoggedIn
      this.redeemAllowed = configuration.redeemAllowed
      this.mbDictionary = dictionary

      if (!configuration.destinationAllowed) {
        this.showMilesNBonus = false
      }
    }

    this.setVehiclesTypes()
    this.setEventListeners()

    if (this.configuration.listView) {
      this.onClickListView()
    } else {
      this.onClickGridView()
    }

    this.setBreakpoint()
    jQuery(window).on('resize', () => {
      this.setBreakpoint()
    })

    this.$nextTick(() => {
      this.stickyOnScroll = new StickyOnScroll(
        this.$refs.stickyElement,
        this.$refs.grid,
        250
      )
    })
  },
  methods: {
    setEventListeners() {
      document.addEventListener('milesNBonusLogStatus', (e) => {
        this.milesNBonusLoggedIn = e.detail.logStatus
        this.redeemAllowed = e.detail.redeemAllowed
      })
    },

    onToggleMiles() {
      document.dispatchEvent(
        new CustomEvent('toggleMiles', { detail: { value: this.toggleMiles } })
      )
    },
    /* eslint-disable no-undef */
    setVehiclesTypes() {
      const arr = this.records.map((i) => i.Categories.split('|')).flat()
      const newArr = _.compact(arr)
      this.vehiclesTypes = _.uniqBy(newArr)
    },

    onChangeSortBy() {
      /* eslint-disable no-undef */
      this.recordsFiltered = _.orderBy(this.recordsFiltered, [this.sortBy])
      this.page = 1
    },

    onClickViewAll() {
      this.page = 1
      this.itemsPerPage = 9999
    },

    setBreakpoint() {
      const { devices, desktops } = constants.breakpoints
      this.breakpoint = lib.scrDevices() ? devices : desktops
    },

    pageChanged(value) {
      this.page = value
      lib.scrollToElem(jQuery(this.$refs.grid), 100)
    },

    onClickGridView() {
      this.page = 1
      this.view = constants.view.grid
      this.itemsPerPage = this.configuration.itemsPerPageGridView
    },

    onClickListView() {
      this.page = 1
      this.view = constants.view.list
      this.itemsPerPage = this.configuration.itemsPerPageListView
    },

    onChangeGuaranteed() {
      this.page = 1
      this.setFilters()
    },

    onSubmitFilters(categories, transmissions, specialCategories, guaranteed) {
      this.page = 1

      this.transmissions = transmissions
      this.specialCategories = specialCategories
      this.guaranteed = guaranteed
      this.setFilters()
    },

    setFilters() {
      this.recordsFiltered = this.records

      // transmissions
      if (this.transmissions.length) {
        this.recordsFiltered = this.recordsFiltered.filter((i) =>
          i.Categories.split('|').some(
            (r) => this.transmissions.indexOf(r) >= 0
          )
        )
      }

      // specialCategories
      if (this.specialCategories.length) {
        this.recordsFiltered = this.recordsFiltered.filter((i) =>
          i.Categories.split('|').some(
            (r) => this.specialCategories.indexOf(r) >= 0
          )
        )
      }

      // guaranteed
      if (this.guaranteed) {
        this.recordsFiltered = this.recordsFiltered.filter((i) => i.Guaranteed)
      }
    },
  },
}
</script>
